import { render, staticRenderFns } from "./PaginaScritture.vue?vue&type=template&id=006b8308"
import script from "./PaginaScritture.vue?vue&type=script&lang=js"
export * from "./PaginaScritture.vue?vue&type=script&lang=js"
import style0 from "./PaginaScritture.vue?vue&type=style&index=0&id=006b8308&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports